import { db } from "./firebase";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  query,
  where,
  orderBy,
  serverTimestamp
} from "firebase/firestore";

const COL = "packages";

export async function getAllPackages() {
  const q = query(collection(db, COL), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function getCustomerPackages(email, warehouse = "USA") {
  // Fetch all customer packages then filter client-side
  // This handles old packages that don't have a warehouse field (default to USA)
  const q = query(
    collection(db, COL),
    where("customerEmail", "==", email.toLowerCase().trim()),
    orderBy("createdAt", "desc")
  );
  const snap = await getDocs(q);
  const all = snap.docs.map(d => ({ id: d.id, ...d.data() }));
  return all.filter(p => (p.warehouse || "USA") === warehouse);
}

export async function createPackage(data) {
  const docRef = await addDoc(collection(db, COL), {
    customerEmail:  data.customerEmail.toLowerCase().trim(),
    customerName:   data.customerName.trim(),
    trackingNumber: data.trackingNumber || "",
    carrier:        data.carrier || "",
    description:    data.description || "",
    weight:         data.weight,
    dimensions:     data.dimensions || "",
    eta:            data.eta || null,
    status:         data.status || "Received",
    notes:          data.notes || "",
    warehouse:      data.warehouse || "USA",
    unit:           data.unit || "7000",
    photoURL:       null,
    photoPath:      null,
    createdAt:      serverTimestamp(),
    updatedAt:      serverTimestamp()
  });
  return docRef.id;
}

export async function updatePackageStatus(id, status, eta, notes) {
  await updateDoc(doc(db, COL, id), {
    status:    status,
    eta:       eta || null,
    notes:     notes || "",
    updatedAt: serverTimestamp()
  });
}

export async function deletePackage(id) {
  await deleteDoc(doc(db, COL, id));
}

export async function updatePackageCustomerDetails(id, data) {
  await updateDoc(doc(db, COL, id), {
    itemName:       data.itemName || "",
    itemValue:      data.itemValue || "",
    invoiceURL:     data.invoiceURL || null,
    invoicePath:    data.invoicePath || null,
    detailsEntered: true,
    updatedAt:      serverTimestamp(),
  });
}
